import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import './../../../../node_modules/react-quill/dist/quill.snow.css';

export default function ExportMenu(props) {
  const { options, aggregatedOptions } = props;
  const { cssModules, dataOptions } = useSelector((state) => state.projectConfig);
  const [hovered, setHovered] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const onClickMenuIcon = () => setShowMenu((prev) => !prev);

  const download = (type) => {
    onClickMenuIcon();

    if (type === 'csv') {
      window.Everviz.downloadCSV(dataOptions);
      return;
    }

    console.log(aggregatedOptions, dataOptions);
    window.Everviz.downloadTableImage(
      {
        options: aggregatedOptions,
        cssModules,
        dataOptions
      },
      type
    );
  };

  return (
    <>
      <div
        className="w-[26px] h-[23px] absolute top-[10px] right-[10px]"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={onClickMenuIcon}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
          <g className="" strokeLinecap="round" transform="">
            <title>{options?.lang?.contextButtonTitle ?? 'Table context menu'}</title>
            <rect
              fill={hovered ? '#e7e6e6' : '#ffffff'}
              className="highcharts-button-box"
              x="0.5"
              y="0.5"
              width="24"
              height="22"
              rx="2"
              ry="2"
              stroke="none"
              strokeWidth="1"
            />
            <path
              fill="#666666"
              d="M 6 6.5 L 20 6.5 M 6 11.5 L 20 11.5 M 6 16.5 L 20 16.5"
              className="highcharts-button-symbol"
              stroke="#666666"
              strokeWidth="3"
            />
            <text x="0" y="15.5" style={{ color: 'rgb(51, 51, 51)', fontWeight: 'normal', fill: 'rgb(51, 51, 51)' }} />
          </g>
        </svg>
      </div>
      {showMenu && (
        <>
          <div className="absolute top-[40px] right-[10px] bg-white border border-[rgb(153, 153, 153)] shadow-bottom z-50 rounded-sm">
            <div className="bg-ev-grey rounded-sm m-2">
              <div
                onClick={() => download('png')}
                className="hover:bg-ev-navy-blue-3 hover:text-white p-[5px] cursor-pointer font-bold text-ev-navy-blue-3"
              >
                {options?.lang?.downloadPNG ?? 'Download PNG image'}
              </div>
              <div
                onClick={() => download('jpeg')}
                className="hover:bg-ev-navy-blue-3 hover:text-white p-[5px] cursor-pointer font-bold text-ev-navy-blue-3"
              >
                {options?.lang?.downloadJPEG ?? 'Download JPEG image'}
              </div>
              <div
                onClick={() => download('pdf')}
                className="hover:bg-ev-navy-blue-3 hover:text-white p-[5px] cursor-pointer font-bold text-ev-navy-blue-3"
              >
                {options?.lang?.downloadPDF ?? 'Download PDF document'}
              </div>
              <div
                onClick={() => download('csv')}
                className="hover:bg-ev-navy-blue-3 hover:text-white p-[5px] cursor-pointer font-bold text-ev-navy-blue-3"
              >
                {options?.lang?.downloadCSV ?? 'Download CSV'}
              </div>
            </div>
          </div>
          <div className="absolute w-full h-full top-0 left-0 z-1" onClick={() => setShowMenu(false)} />
        </>
      )}
    </>
  );
}
